
import { Button } from "@/components/ui/button";
import { ExternalLink } from "lucide-react";

interface CompanyActionButtonsProps {
  handleViewCompanyProfile: () => void;
}

export function CompanyActionButtons({ handleViewCompanyProfile }: CompanyActionButtonsProps) {
  return (
    <div className="flex flex-wrap gap-2">
      <Button
        variant="default"
        onClick={handleViewCompanyProfile}
        className="mt-4 bg-redflags-red hover:bg-redflags-red/90"
      >
        <ExternalLink className="w-4 h-4 mr-2" />
        View Company Profile
      </Button>
    </div>
  );
}
